import type { WorkflowTimelineEntryData } from '../../types/workflowTimelineEntry';

/**
 * For actions, prefer actionMeta.actionName; otherwise use stepName or jobType.
 */
export function resolveTimelineEventTitle(
  entry: WorkflowTimelineEntryData,
  fallbackTitle: string
): string {
  if (entry.entryType === 'ACTION') {
    return (
      entry.actionMeta?.actionName ?? entry.entryMeta?.stepName ?? fallbackTitle
    );
  }
  return entry.entryMeta?.stepName ?? entry.entryMeta?.jobType ?? fallbackTitle;
}
